// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './vuex/'
import 'lib-flexible';

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0); // 滚动到顶部
    next();
});

Vue.config.productionTip = false

/* eslint-disable no-new */
window.ROOT_APP = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js